export const catClasses = {
  heart: 'med-heart',
  diuretic: 'med-diuretic',
  stomach: 'med-stomach',
  blood: 'med-blood',
  other: 'med-other'
}

export const catIcons = {
  heart: '\u2764\uFE0F',
  diuretic: '\uD83D\uDCA7',
  stomach: '\uD83D\uDC9C',
  blood: '\uD83E\uDE78',
  other: '\uD83D\uDC8A'
}

export const dotColors = ['#e86c50', '#4a8fd4', '#34a66c', '#8b6cc1', '#d4930a', '#d94452']

export const typeLabels = {
  bottle: 'Bottle',
  breast: 'Breast',
  tube: 'Tube',         // legacy — pre-2026-04 rows; users re-categorize at their pace
  ng_tube: 'NG Tube',
  nj_tube: 'NJ Tube',
  g_tube: 'G Tube',
  j_tube: 'J Tube',
}
export const typeCls = {
  bottle: 't-feed-bottle',
  breast: 't-feed-breast',
  tube: 't-feed-tube',
  ng_tube: 't-feed-tube',
  nj_tube: 't-feed-tube',
  g_tube: 't-feed-tube',
  j_tube: 't-feed-tube',
}
export const activityIcons = { med: '\uD83D\uDC8A', feed: '\uD83C\uDF7C', weight: '\u2696\uFE0F', tracker: '\uD83D\uDCCB', note: '\uD83D\uDCDD' }
